(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').controller('FiltroRelatorio', FiltroRelatorio);

  function FiltroRelatorio($state, FiltroRelatorioService, $stateParams,
    ngsalConfig, i18n, PromotorService) {

      var vm = this;

      const FORMATO_MES = 'MM';
      const FORMATO_MES_EXTENSO = 'MMMM';
      const FORMATO_ANO = 'YYYY';
      const FORMATO_ANO_MES = 'YYYYMM';

      vm.init = init;
      vm.loadRelatorios = loadRelatorios;
      vm.visualizarRelatorio = visualizarRelatorio;
      vm.loadAnos = loadAnos;
      vm.loadMeses = loadMeses;
      vm.isSearchEnabled = isSearchEnabled;
      vm.carregaSituacoesPossiveis = carregaSituacoesPossiveis;
      vm.consultarPromotor = consultarPromotor;
      vm.versionApi = ngsalConfig.apiVersion;

      vm.init();

      function loadRelatorios() {

        vm.periodoSelecionado =
          vm.anoSelecionado + moment().month(vm.mesSelecionado).format(FORMATO_MES);

        FiltroRelatorioService.getRelatoriosByPromotorAndPeriodoAndSituacao(
          vm.promotorSelecionado.originalObject.pessDk,
          vm.periodoSelecionado,
          vm.situacao.value).then(loadRelatoriosOnSuccess);

        function loadRelatoriosOnSuccess(data) {
          vm.relatoriosByOrgaoList = data;

          if (vm.relatoriosByOrgaoList.length === 1) {
            vm.expandAccordion = true;
          }
        }
      }

      function consultarPromotor(query, timeoutPromise) {
        return PromotorService.consultarPromotor(query, timeoutPromise);
      }

      function visualizarRelatorio(relatorio, orgao) {
        FiltroRelatorioService
          .visualizarRelatorio(relatorio, orgao, vm.periodoSelecionado, vm.promotorSelecionado.originalObject.pessDk)
          .then(() => {
            $state.go('visualizacao.principal', {
              periodoSelecionado: vm.periodoSelecionado,
              nomeOrgaoFiltrado: vm.nomeOrgaoFilter,
              promotorSelecionado: vm.promotorSelecionado,
              relDkSelecionado: relatorio.id,
              situacaoSelecionada: vm.situacao
            });
        });
      }

      function init() {

        vm.loadAnos();

        // Usado pelo Tour
        vm.expandAccordion = false;

        if ($state.params.referer === 'botaoVoltar') {
          vm.nomeOrgaoFilter = $state.params.nomeOrgaoFiltrado;
          vm.periodoSelecionado = $state.params.periodoSelecionado;
          vm.anoSelecionado = moment(vm.periodoSelecionado, FORMATO_ANO_MES).format(FORMATO_ANO);
          vm.mesSelecionado = moment(vm.periodoSelecionado, FORMATO_ANO_MES).format(FORMATO_MES_EXTENSO);

          vm.promotorSelecionado = $state.params.promotorSelecionado;
          vm.nomePromotorSelecionado = vm.promotorSelecionado.originalObject.nomePromotor;

          vm.loadMeses();

          vm.carregaSituacoesPossiveis().then(() => {
            vm.loadRelatorios();
          });

        } else {
          vm.carregaSituacoesPossiveis();
        }
      }

      function carregaSituacoesPossiveis() {
        var promise = FiltroRelatorioService.carregaSituacoesPossiveis()
          .then( (response) => {
            vm.opcoesFiltroSituacao = response;

            if ($state.params.referer === 'botaoVoltar') {
              vm.situacao = $state.params.situacaoSelecionada;
            } else {
              vm.situacao = vm.opcoesFiltroSituacao[0];
            }
          });

          return promise;
      }

      function loadAnos() {

        vm.anos = [];

        var minYear = i18n.translate("application.startYear");
        var currentYear = moment().year();

        while (currentYear >= minYear) {
          vm.anos.push(currentYear--);
        }
      }

      function loadMeses() {
        vm.meses = [];

        var currentYear = moment().year();

        if (currentYear === parseInt(vm.anoSelecionado)) {
          moment.months().forEach(function (monthName) {
            var month = moment().month(monthName);

            if (moment(month).isSameOrBefore(moment(), 'month')) {
              vm.meses.push(monthName);
            }
          });
        } else {
          vm.meses = moment.months();
        }
      }

      function isSearchEnabled() {
        return vm.promotorSelecionado && vm.anoSelecionado && vm.mesSelecionado;
      }
    }

  })();
